import React from 'react';

import * as analytics from 'analytics/Analytics';
import OnboardingConstants from 'constants/OnboardingConstants';
// @ts-expect-error
// eslint-disable-next-line unused-imports/no-unused-imports
import * as tutorial from 'help/eln/Tutorial';
import ChecklistItemListing from 'onboarding/ChecklistItemListing';
import ChecklistPanelLink from 'onboarding/ChecklistPanelLink';
import {makeGettingStartedItems} from 'onboarding/OnboardingUtils';

interface Props {
  currentUser: {
    url_identifier: string;
  };
  tasks: Array<{
    key: string;
    completed: boolean;
  }>;
  completed: boolean;
  hasSpace: boolean;
}

interface State {
  isOpen: boolean;
}

class GettingStartedPanel extends React.Component<Props, State> {
  state: State = {
    isOpen: true,
  };

  _handleToggleOpen = (): void => {
    const newIsOpen = !this.state.isOpen;
    this.setState({isOpen: newIsOpen});
    const action = newIsOpen ? 'expanded' : 'minimized';
    analytics.track('onboarding_checklist', action, {
      checklist: 'sidepanel',
      checklistTitle: 'Getting Started',
      checklistReward: '1GB_earned',
      numberOfTasks: 5,
      eventLastModified: 'FY21_Q1a2',
    });
  };

  render(): JSX.Element {
    const {tasks, completed, hasSpace} = this.props;
    return (
      <div style={{position: 'relative', marginTop: '12px'}}>
        <ChecklistItemListing
          title="Get started with Benchling"
          module={OnboardingConstants.MODULES.GETTING_STARTED}
          listItems={makeGettingStartedItems(tasks, completed, !hasSpace)}
          collapsed={!this.state.isOpen}
          onChangeCollapsed={this._handleToggleOpen}
          collapsedNode={
            <ChecklistPanelLink
              displayText="Get started with Benchling"
              icon="chevron-right"
              onClick={this._handleToggleOpen}
            />
          }
          completed={completed}
          fixedSize={false}
          openIndex={null}
        />
      </div>
    );
  }
}

export default GettingStartedPanel;
